import { render } from "./selectedDropMenu.vue?vue&type=template&id=0161c3f7"
import script from "./selectedDropMenu.vue?vue&type=script&lang=js"
export * from "./selectedDropMenu.vue?vue&type=script&lang=js"

import "./selectedDropMenu.vue?vue&type=style&index=0&id=0161c3f7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__